import React from "react";
import { Table, Tag, Space } from "antd";
import { Modal } from "react-bootstrap";
import { FiInfo } from "react-icons/fi";

export default function AssetAlertsTab() {
	const [selectedAlert, setSelectedAlert] = React.useState(null);
	const [showModal, setShowModal] = React.useState(false);

	const alertData = [
		{
			id: 1,
			alertId: "ALT-001",
			assetName: "SCADA-SERVER-01",
			severity: "Critical",
			type: "Unauthorized Access",
			timestamp: "2024-01-15 14:32:15",
			description: "Multiple failed login attempts detected",
			status: "Active",
		},
		{
			id: 2,
			alertId: "ALT-002",
			assetName: "HMI-WORKSTATION-02",
			severity: "High",
			type: "Configuration Change",
			timestamp: "2024-01-15 13:45:22",
			description: "Firewall rules have been modified",
			status: "Acknowledged",
		},
		{
			id: 3,
			alertId: "ALT-003",
			assetName: "COMPUTER-WS-06",
			severity: "High",
			type: "Malware Detection",
			timestamp: "2024-01-15 12:15:08",
			description: "Suspicious process behavior detected",
			status: "Active",
		},
		{
			id: 4,
			alertId: "ALT-004",
			assetName: "NETWORK-DEVICE-04",
			severity: "Medium",
			type: "Performance Issue",
			timestamp: "2024-01-15 11:30:45",
			description: "Network latency above threshold",
			status: "Resolved",
		},
		{
			id: 5,
			alertId: "ALT-005",
			assetName: "INDUSTRIAL-PLC-03",
			severity: "Medium",
			type: "Firmware Update",
			timestamp: "2024-01-15 10:20:33",
			description: "Firmware update available",
			status: "Acknowledged",
		},
	];

	const getSeverityColor = (severity) => {
		const colorMap = {
			Critical: "#ff4d4f",
			High: "#ff7a45",
			Medium: "#faad14",
			Low: "#52c41a",
		};
		return colorMap[severity];
	};

	const getStatusColor = (status) => {
		const colorMap = {
			Active: "#ff4d4f",
			Acknowledged: "#faad14",
			Resolved: "#52c41a",
		};
		return colorMap[status];
	};

	const showAlertDetails = (record) => {
		setSelectedAlert(record);
		setShowModal(true);
	};

	const columns = [
		{
			title: "Alert ID",
			dataIndex: "alertId",
			key: "alertId",
			width: 100,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Asset Name",
			dataIndex: "assetName",
			key: "assetName",
			width: 150,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Severity",
			dataIndex: "severity",
			key: "severity",
			width: 100,
			render: (severity) => <Tag color={getSeverityColor(severity)}>{severity}</Tag>,
		},
		{
			title: "Type",
			dataIndex: "type",
			key: "type",
			width: 150,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Timestamp",
			dataIndex: "timestamp",
			key: "timestamp",
			width: 150,
			render: (text) => <span>{text}</span>,
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			width: 120,
			render: (status) => <Tag color={getStatusColor(status)}>{status}</Tag>,
		},
		{
			title: "Action",
			key: "action",
			width: 100,
			render: (_, record) => (
				<Space size="small">
					<button
						type="button"
						className="btn btn-sm btn-primary fw-bold"
						onClick={() => showAlertDetails(record)}
					>
						<FiInfo size={16} className="me-2" style={{ display: "inline" }} />
						Details
					</button>
				</Space>
			),
		},
	];

	return (
		<>
			<div className="mt-5">
				<Table
					columns={columns}
					dataSource={alertData}
					rowKey="id"
					className="mb-0 table antd-override"
					pagination={{
						pageSize: 10,
						className: 'mb-0',
						showTotal: (total, range) => (
							<span>
								{range[0]} to {range[1]} of {total} alerts
							</span>
						),
					}}
				/>
			</div>

			{selectedAlert && (
				<Modal
					show={showModal}
					onHide={() => setShowModal(false)}
					className="modal fade"
					contentClassName="rounded-lg"
					dialogClassName="modal-dialog"
				>
					<Modal.Header className="bg-light border-bottom d-flex justify-content-between align-items-center" closeButton>
						<Modal.Title className="fw-bold text-gray-900">Alert Details</Modal.Title>
					</Modal.Header>
					<Modal.Body className="p-6">
						<div className="mb-5">
							<div className="text-gray-600 fw-semibold mb-2">Alert ID</div>
							<div className="text-gray-900 fs-6 fw-bold">{selectedAlert.alertId}</div>
						</div>

						<div className="mb-5">
							<div className="text-gray-600 fw-semibold mb-2">Asset Name</div>
							<div className="text-gray-900 fs-6 fw-bold">{selectedAlert.assetName}</div>
						</div>

						<div className="mb-5">
							<div className="text-gray-600 fw-semibold mb-2">Alert Type</div>
							<div className="text-gray-900 fs-6 fw-bold">{selectedAlert.type}</div>
						</div>

						<div className="mb-5">
							<div className="text-gray-600 fw-semibold mb-2">Severity Level</div>
							<div>
								<Tag color={getSeverityColor(selectedAlert.severity)}>
									{selectedAlert.severity}
								</Tag>
							</div>
						</div>

						<div className="mb-5">
							<div className="text-gray-600 fw-semibold mb-2">Description</div>
							<div className="text-gray-900 fs-6">{selectedAlert.description}</div>
						</div>

						<div className="mb-5">
							<div className="text-gray-600 fw-semibold mb-2">Timestamp</div>
							<div className="text-gray-900 fs-6 fw-bold">{selectedAlert.timestamp}</div>
						</div>

						<div>
							<div className="text-gray-600 fw-semibold mb-2">Status</div>
							<div>
								<Tag color={getStatusColor(selectedAlert.status)}>
									{selectedAlert.status}
								</Tag>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer className="bg-light border-top">
						<button
							type="button"
							onClick={() => setShowModal(false)}
							className="btn btn-secondary fw-bold"
						>
							Close
						</button>
					</Modal.Footer>
				</Modal>
			)}
		</>
	);
}
